export default {
  methods: {
    renderStatusRings(items) {
      if (!Array.isArray(items)) return;

      // 统一的渐变色方案
      const gradientStart = 'rgba(0, 218, 214, 1)'; // 青色
      const gradientEnd = 'rgba(254, 219, 101, 1)'; // 黄色
      const textColor = 'rgba(46, 249, 198, 1)'; // 百分比文字颜色

      // 每个进度环的数值颜色（根据图片）
      const valueColors = [
        '#FFA726', // 已上架 - 橙黄色
        '#5BE18D', // 待上架 - 绿色
        '#2EF9C6', // 无需上架 - 青色
        '#FF6B9D' // 暂缓上架 - 粉红色
      ];

      items.forEach((it, idx) => {
        // 在 v-for 中，ref 会是一个数组
        let refElement = this.$refs[it.ref];
        if (Array.isArray(refElement)) {
          refElement = refElement[0];
        }

        if (!refElement) {
          console.warn(`ref ${it.ref} not found`);
          return;
        }

        const percent = (it.percent && it.percent.replace('%', '')) || 0;

        const option = {
          series: [
            // 外圆环（装饰边框）
            {
              type: 'pie',
              radius: ['79%', '81%'],
              center: ['50%', '35%'],
              silent: true,
              clockwise: true,
              startAngle: 90,
              hoverAnimation: false,
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              data: [{
                value: 100,
                itemStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 1,
                      color: 'rgba(68, 215, 182, 1)'
                    }, ]
                  }
                }
              }],
              z: 1
            },
            {
              type: 'pie',
              radius: ['87%', '89%'],
              center: ['50%', '35%'],
              silent: true,
              clockwise: true,
              startAngle: 90,
              hoverAnimation: false,
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              data: [{
                value: 100,
                itemStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 1,
                      color: 'rgba(28, 236, 237, 0.37)'
                    }, ]
                  }
                }
              }],
              z: 1
            },
            // 进度圆环（渐变色，加粗）
            {
              type: 'pie',
              radius: ['52%', '68%'],
              center: ['50%', '35%'],
              silent: true,
              clockwise: true,
              startAngle: 90,
              hoverAnimation: false,
              label: {
                show: false
              },
              labelLine: {
                show: false
              },
              data: [{
                  value: percent,
                  itemStyle: {
                    color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 1,
                      y2: 1,
                      colorStops: [{
                          offset: 0,
                          color: gradientStart
                        },
                        {
                          offset: 1,
                          color: gradientEnd
                        }
                      ]
                    },
                    shadowColor: gradientEnd,
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowOffsetY: 0
                  }
                },
                {
                  value: 100 - percent,
                  itemStyle: {
                    color: 'rgba(3, 74, 59, 1)'
                  }
                }
              ],
              z: 2,
              animationDuration: 1500,
              animationEasing: 'cubicOut'
            }
          ],
          graphic: [
            // 百分比文字
            {
              type: 'text',
              left: 'center',
              top: '30%',
              style: {
                text: `${percent}%`,
                fill: textColor,
                fontSize: 20,
                fontWeight: 'bold',
                fontFamily: 'YinHei',
                textAlign: 'center'
              }
            },
            // 标题文字
            {
              type: 'text',
              left: 'center',
              bottom: '0%',
              style: {
                text: it.name || '',
                fill: 'rgba(255, 255, 255, 0.85)',
                fontSize: 12,
                fontFamily: 'PingFangSC',
                textAlign: 'center'
              }
            },
            // 数值
            {
              type: 'text',
              left: 'center',
              bottom: '13%',
              style: {
                text: String(it.value || 0),
                fill: valueColors[idx % valueColors.length],
                fontSize: 16,
                fontWeight: 'bold',
                fontFamily: 'YinHei',
                textAlign: 'center'
              }
            }
          ]
        };

        // 销毁旧实例
        const oldInstance = this.$echarts.getInstanceByDom(refElement);
        if (oldInstance) {
          oldInstance.dispose();
        }

        // 创建新实例
        const chartInstance = this.$echarts.init(refElement);
        chartInstance.setOption(option);

        // 绑定resize事件
        window.addEventListener('resize', () => {
          chartInstance.resize();
        });
      });
    }
  }
}
